import { render, staticRenderFns } from "./GameTestingScore.vue?vue&type=template&id=53a3d24d&scoped=true&"
import script from "./GameTestingScore.vue?vue&type=script&lang=js&"
export * from "./GameTestingScore.vue?vue&type=script&lang=js&"
import style0 from "./GameTestingScore.vue?vue&type=style&index=0&id=53a3d24d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a3d24d",
  null
  
)

export default component.exports